import './styles.scss'

function About() {
  return (
    <>
      <header className="header">
        <h1>About</h1>
      </header>
      <section className="t">
        <p>
          Profound Bathroom Graffiti Radio is a site/repo for left field
          electronic/experimental music, sound art, rare records, talks and
          field sounds. Operating out of Poneke, Aotearoa/New Zealand
        </p>
        <p>
          This application is hosted on Railway.app, constructed using React
          with TypeScript, utilizes AWS S3 for file storage hosting, and P5
          React-TypeScript for the 3D graphics
        </p>
      </section>
    </>
  )
}

export default About
